export default __webpack_public_path__ + "438965b12f181e7c0418cab8f952e56d.png";